module.exports = __webpack_public_path__ + "static/img/maskCount_puple.8ea62175.png";